<!-- 新闻资讯 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container recharge-manage">
      <el-form size="small" :inline="true" :model="listQuery" >
        <!-- 关键词 -->
        <el-form-item :label="$t('label.keyword') + ':'">
          <el-input v-model.trim="listQuery.title" style="width:140px;"/>
        </el-form-item>
        <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
      </el-form >
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="60" header-align="center" align="center">
          <template v-slot="{row}">
            <el-button circle size="mini" icon="el-icon-search" :title="$t('button.view')" @click="viewTableBtn(row)" />
          </template>
        </el-table-column>
        <!-- 标题 -->
        <el-table-column :label="$t('icInformation.title')" prop="title" align="center"/>
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"
import { icAnnouncesList1 } from '@/api/ic/IcAnnounce'

export default {
  name: 'News',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      tableLoading: false,
      list: [{}],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      icAnnouncesList1({ ...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        this.btnLoading = false
        this.tableLoading = false
      }).catch(err => {
        console.warn(err)
        this.btnLoading = false
        this.tableLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    viewTableBtn(row) {
      this.$router.push({ name: 'NewsView', params:{ id: row.announceId } })
    }
  }
}
</script>

<style scoped>

</style>
